import Slider  from './lib/slider';

new Slider().init();
